interface Props {
  className?: string;
}

export function MetresPerShiftIcon({ className }: Props) {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Bar 1 — open-top U shape */}
      <path d="M2 14 L2 20 L5 20 L5 14" />
      {/* Bar 2 */}
      <path d="M7 9 L7 20 L10 20 L10 9" />
      {/* Bar 3 */}
      <path d="M12 12 L12 20 L15 20 L15 12" />
      {/* Bar 4 */}
      <path d="M17 7 L17 20 L20 20 L20 7" />

      {/* Trend line connecting mid-tops → rising arrow */}
      <polyline points="3.5,14 8.5,9 13.5,12 22,2" />

      {/* Arrowhead */}
      <polyline points="17,2 22,2 22,7" />
    </svg>
  );
}
